import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PublicIcon(props: IconProps) {
    return <Icon {...props} iconKey={"public"}/>
}
